import { render, staticRenderFns } from "./LandingWeddingFR.vue?vue&type=template&id=49430082&scoped=true"
import script from "./LandingWeddingFR.vue?vue&type=script&lang=js"
export * from "./LandingWeddingFR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49430082",
  null
  
)

export default component.exports